/**
 * GeoMap — Phase 3.23. Full-page geographic drill-down.
 *
 * Loads accessible programs into a filter dropdown so the map can be
 * scoped to a single program. Renders <GeoMapView /> below.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import api from "../lib/api";
import Layout from "../components/Layout";
import GeoMapView from "../components/GeoMapView";

export default function GeoMap() {
  const [programs, setPrograms] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    api.get("/programs").then(({ data }) => setPrograms(data || [])).catch(() => {});
  }, []);

  return (
    <Layout>
      <div className="space-y-5">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <Link to="/" className="inline-flex items-center text-xs text-slate-500 hover:text-emerald-700">
            <ChevronLeft className="w-3 h-3 mr-1" /> Back to dashboard
          </Link>
          <h1 className="font-heading text-3xl font-semibold tracking-tight mt-1">Geographic intelligence</h1>
          <p className="text-sm text-slate-600">
            Drill from country → state → LGA. Pick any numeric indicator to colour-grade the map.
          </p>
        </div>
        <div>
          <label className="label-overline">Program scope</label>
          <select
            multiple
            className="block min-w-[280px] max-w-[400px] mt-1 border border-slate-300 rounded-sm px-2 py-1 text-xs bg-white h-24"
            value={selected}
            onChange={(e) => setSelected(Array.from(e.target.selectedOptions, (o) => o.value))}
            data-testid="geo-page-program-select"
          >
            {programs.map((p) => (
              <option key={p.id} value={p.id}>{p.name}</option>
            ))}
          </select>
          <p className="text-[10px] text-slate-400 mt-0.5">⌘/Ctrl-click to multi-select. Empty = all accessible.</p>
        </div>
      </div>
      <GeoMapView programIds={selected} />
      </div>
    </Layout>
  );
}
